import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  videoBackgroundContainer: {
    position: "relative",
    width: "100%",
    height: "fit-content",
    overflow: "hidden",
  },
  imageBackgroundContainer: {
    position: "relative",
    width: "100%",
    height: "fit-content",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  solidColorContainer: {
    position: "relative",
    width: "100%",
    height: "fit-content",
  },
  backgroundVideo: {
    position: "absolute",
    top: "50%",
    left: "50%",
    minWidth: "100%",
    minHeight: "100%",
    width: "auto",
    height: "auto",
    transform: "translate(-50%, -50%)",
    zIndex: 10,
    objectFit: "cover",
  },
  contentOverlay: {
    position: "relative",
    zIndex: 20,
    width: "100%",
    height: "100%",
    // `minHeight` will be dynamically applied, so no hardcoded value
  },
}));

export default useStyles;

export const withBackground = (Component, componentType) => {
  return (props) => {
    const classes = useStyles();
    const contentRef = useRef(null); // Create a ref to track the component height
    const [minHeight, setMinHeight] = useState(0);

    useEffect(() => {
      // Check the height of the component when it mounts
      if (contentRef.current) {
        console.log("withBackground, ", contentRef.current, componentType);
        setMinHeight(contentRef.current.offsetHeight);
      }
    }, [contentRef.current]); // Recalculate whenever the content ref changes

    if (!componentType || !componentType.background_type) {
      return <Component {...props} />;
    }
    const { background_type, video, background_image, solid_color } =
      componentType;

    switch (background_type) {
      case "video":
        return (
          <div className={classes.videoBackgroundContainer}>
            <video
              autoPlay
              muted
              loop
              playsInline
              className={classes.backgroundVideo}
            >
              <source
                src={
                  video ||
                  "https://b2b2c-staging.s3.amazonaws.com/ta_template_bg_video/3/0.27184562360900066/2mb_vid.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA4VVQQYNZK6HV4DW2%2F20250915%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250915T090614Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=b9d82862000a328bef71b9df5cbe540f1bbd4f9a6b2bac67cbb7af24eafa0c29"
                }
                type="video/mp4"
              />
            </video>
            <div
              className={classes.contentOverlay}
              style={{ minHeight: minHeight }}
            >
              <Component ref={contentRef} {...props} />
            </div>
          </div>
        );

      case "image":
        return (
          <div
            className={classes.imageBackgroundContainer}
            style={{
              background: `linear-gradient(
                    rgba(0, 0, 0, 0), 
                    rgba(0, 0, 0, 0)
                  ),
                  url("${
                    background_image || background_image
                  }") no-repeat center center`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div
              className={classes.contentOverlay}
              style={{ minHeight: minHeight }}
            >
              <Component ref={contentRef} {...props} />
            </div>
          </div>
        );

      case "solid_color":
        return (
          <div
            className={classes.solidColorContainer}
            style={{
              backgroundColor: solid_color || "#ffffff",
            }}
          >
            <div
              className={classes.contentOverlay}
              style={{ minHeight: minHeight }}
            >
              <Component ref={contentRef} {...props} />
            </div>
          </div>
        );

      default:
        return <Component {...props} />;
    }
  };
};
